module.exports = __webpack_public_path__ + "assets/img/16-s.e183b68.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/photo/objects/16-s.jpg
// module id = 4R1l
// module chunks = 0